import { clearAllOperationalAlerts } from "@/lib/operational-alert-events";

export const SYSTEM_ERROR_EVENT = "epitrack:system-error";

let takeoverRequested = false;

export function notifySystemError() {
  if (typeof window === "undefined" || takeoverRequested) {
    return;
  }

  takeoverRequested = true;
  clearAllOperationalAlerts();
  window.dispatchEvent(new Event(SYSTEM_ERROR_EVENT));
}
